module.exports = __webpack_public_path__ + "img/pic_bt_en.207fac9d.png";